import { DeviceType } from '../models/DeviceType';
import { DataAlertContextType, DataAlertRecipientType, DataAlertSuspendState } from '../ServerApi/types/IDataAlert';
import { IGroupInfo } from './IGroupInfo';
import { IUserInfo } from './IUserInfo';
import { INamedItemInfo, IOwnedItemInfo } from './resourceInfoParts';

export interface IDataAlertInfo extends INamedItemInfo, IOwnedItemInfo {
  context: DataAlertContextInfo;
  displayRecipients: DataAlertRecipientInfo[];
  recipientsCount: number;
  isCurrentUserSubscribed: boolean;
  lastChecked?: Date;
  lastSentForCurrentUser?: Date;
  notificationIntervalInMinutes: number;
  deviceType: DeviceType;
  suspendState: DataAlertSuspendState;
  isPublic: boolean;
}

export const DataAlertRecipientInfoType = {
  isUser: (r: DataAlertRecipientInfo): r is UserDataAlertRecipientInfo => r.type === 'user',
  isGroup: (r: DataAlertRecipientInfo): r is GroupDataAlertRecipientInfo => r.type === 'group'
};

export interface DataAlertRecipientInfo {
  type: DataAlertRecipientType;
}

export interface UserDataAlertRecipientInfo extends DataAlertRecipientInfo {
  user: IUserInfo;
}

export interface GroupDataAlertRecipientInfo extends DataAlertRecipientInfo {
  group: IGroupInfo;
}

export interface DataAlertContextInfo extends INamedItemInfo {
  type: DataAlertContextType;
  path: string;
  isViewModified: boolean;
}
